<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <span>税筹订单</span>
        </div>
      </template>

      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>商户编号</span>
          <a-input v-model.trim="paramsData.merchantNo" allow-clear placeholder="请输入商户编号" style="width: 200px"/>
        </div>
        <div class="item">
          <span>订单状态</span>
          <a-select v-model.trim="paramsData.status" allow-clear placeholder="请选择状态" style="width: 150px">
            <a-select-option v-for="(item, key) in taxDict.orderStatus" :key="key" :value="Number(key)">{{ item.label }}</a-select-option>
          </a-select>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 操作按钮区域 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button v-if="$authority('taxOrderCreate')" icon="plus" type="primary" @click="createOrder">创建订单</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.orderNo"
          >
            <template slot="accountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.accountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
            <template slot="oppAccountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.oppAccountName" :account-no="text" :show-account-name="true" :show-account-no="true"
                          :bank-name="record.oppBankName"
                          :bank-no="record.oppBankNo" :is-wallet="record.oppAccountType==='1'"/>
            </template>
            <template slot="merchantInfo" slot-scope="text, record">
              <div>{{ record.merchantNo }}</div>
              <div style="font-size: 12px; color: #999;">{{ record.merchantName }}</div>
            </template>
            <template slot="sfAccountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.accountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
            <template slot="sfOppAccountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.oppAccountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
            <template slot="psAccount" slot-scope="text, record">
              <WalletInfo :account-name="record.oppAccountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
            <template slot="status" slot-scope="text, record">
              <a-popover v-if="record.failReason" title="失败原因">
                <template #content>{{ record.failReason }}</template>
                <a-tag :color="taxDict.orderStatus[text]?.color || 'default'">
                  {{ taxDict.orderStatus[text]?.label || text }}
                </a-tag>
              </a-popover>
              <a-tag v-else :color="taxDict.orderStatus[text]?.color || 'default'">
                {{ taxDict.orderStatus[text]?.label || text }}
              </a-tag>
            </template>
            <template slot="totalAmount" slot-scope="text">
              <Balance :amount="text" prefix="￥"></Balance>
            </template>
            <template slot="serviceFee" slot-scope="text">
              <Balance :amount="text" prefix="￥"></Balance>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button v-if="$authority('taxOrderView')" icon="eye" style="color: #1890ff;" type="link" @click="viewBtn(record)">查看</a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="paginationBox">
        <LcfsPagination
            :fn="getTableData"
            :page-no.sync="pagination.pageNo"
            :page-size.sync="pagination.pageSize"
            :total="pagination.total"
        />
      </div>
    </a-card>

    <!-- 订单详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        :destroyOnClose="true"
        :footer="null"
        title="订单详情"
        width="1200px"
        @cancel="viewModalVisible = false"
    >
      <div v-if="viewData" class="order-detail">
        <!-- 基本信息 -->
        <a-card :bordered="false" class="detail-section" size="small" title="订单基本信息">
          <a-descriptions :column="3" bordered size="small">
            <a-descriptions-item label="订单号">
              <span class="detail-value">{{ viewData.orderNo }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="商户编号">
              <span class="detail-value">{{ viewData.merchantNo }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="商户名称">
              <span class="detail-value">{{ viewData.merchantName }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="付款账户">
              <WalletInfo :account-name="viewData.accountName" :account-no="viewData.accountNo" :show-account-name="true" :show-account-no="true"/>
            </a-descriptions-item>
            <a-descriptions-item label="收款账户">
              <WalletInfo :account-name="viewData.oppAccountName" :account-no="viewData.oppAccountNo" :bank-name="viewData.oppBankName"
                          :bank-no="viewData.oppBankNo" :is-wallet="viewData.oppAccountType==='1'" :show-account-name="true" :show-account-no="true"/>
            </a-descriptions-item>
            <a-descriptions-item label="订单金额">
              <Balance :amount="viewData.totalAmount" prefix="￥ "></Balance>
            </a-descriptions-item>
            <a-descriptions-item v-if="viewData.serviceFee > 0  && $authority('taxOrderFee')" label="服务费">
              <Balance :amount="viewData.serviceFee" prefix="￥ "></Balance>
            </a-descriptions-item>
            <a-descriptions-item label="订单状态">
              <a-tag :color="taxDict.orderStatus[viewData.status]?.color || 'default'">
                {{ taxDict.orderStatus[viewData.status]?.label || viewData.status }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="创建时间">
              <span class="detail-value">{{ formatDateTime(viewData.createTime) }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- 服务费记录 -->
        <a-card v-if="viewData.serviceFeeRecord  && $authority('taxOrderFee')" :bordered="false" class="detail-section" size="small" title="服务费记录">
          <a-table
              :columns="serviceFeeColumns"
              :data-source="viewData.serviceFeeRecord ? [viewData.serviceFeeRecord] : []"
              :pagination="false"
              size="small"
          >
            <template slot="feeAmount" slot-scope="text">
              <Balance :amount="text" prefix="￥"></Balance>
            </template>
            <template slot="recordStatus" slot-scope="text, record">
              <a-popover v-if="record.failReason" title="失败原因">
                <template #content>{{ record.failReason }}</template>
                <a-tag :color="taxDict.serviceFeeStatus[text]?.color || 'default'">
                  {{ taxDict.serviceFeeStatus[text]?.label || text }}
                </a-tag>
              </a-popover>
              <a-tag v-else :color="taxDict.serviceFeeStatus[text]?.color || 'default'">
                {{ taxDict.serviceFeeStatus[text]?.label || text }}
              </a-tag>
            </template>
            <template slot="settleTime" slot-scope="text">
              {{ formatDateTime(text) }}
            </template>
            <template slot="sfAction" slot-scope="text, record">
              <a-button
                  v-if="record.paymentStatus !== 2 && $authority('serviceFeeRetry')"
                  icon="redo"
                  size="small"
                  type="link"
                  @click="retryServiceFee(record)"
              >
                重试
              </a-button>
            </template>
            <template slot="sfAccountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.accountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
            <template slot="sfOppAccountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.oppAccountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
          </a-table>
        </a-card>

        <!-- 分润记录 -->
        <a-card v-if="viewData.profitShareList && viewData.profitShareList.length > 0  && $authority('taxOrderFee')" :bordered="false" class="detail-section"
                size="small" title="分润记录">
          <a-table
              :columns="profitShareColumns"
              :data-source="viewData.profitShareList || []"
              :pagination="false"
              size="small"
          >
            <template slot="shareAmount" slot-scope="text">
              <Balance :amount="text" prefix="￥"></Balance>
            </template>
            <template slot="recordStatus" slot-scope="text, record">
              <a-popover v-if="record.failReason" title="失败原因">
                <template #content>{{ record.failReason }}</template>
                <a-tag :color="taxDict.profitShareStatus[text]?.color || 'default'">
                  {{ taxDict.profitShareStatus[text]?.label || text }}
                </a-tag>
              </a-popover>
              <a-tag v-else :color="taxDict.profitShareStatus[text]?.color || 'default'">
                {{ taxDict.profitShareStatus[text]?.label || text }}
              </a-tag>
            </template>
            <template slot="shareTime" slot-scope="text">
              {{ formatDateTime(text) }}
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button
                  v-if="record.paymentStatus !== 2   && $authority('profitShareRetry')"
                  icon="redo"
                  size="small"
                  type="link"
                  @click="retryProfitShare(record)"
              >
                重试
              </a-button>
            </template>
            <template slot="psAccount" slot-scope="text, record">
              <WalletInfo :account-name="record.oppAccountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
          </a-table>
        </a-card>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import Balance from "@/view/components/Balance.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import authority from "@/utils/authority";
import {taxDict} from '@/utils/bizDict/taxDict';

export default {
  name: 'TaxOrder',
  components: {LcfsPagination, Balance, WalletInfo},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      tableData: [],
      viewModalVisible: false,
      viewData: null,

      paramsData: {
        merchantNo: '',
        status: null,
      },

      taxDict,

      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },
        {
          title: "订单号",
          dataIndex: "orderNo",
          align: "center",
          width: 180
        },
        {
          title: "商户",
          dataIndex: "merchantNo",
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'merchantInfo'}
        },
        {
          title: "付款账户",
          dataIndex: "accountNo",
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'accountNo'}
        },
        {
          title: "收款账户",
          dataIndex: "oppAccountNo",
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'oppAccountNo'}
        },

        {
          title: "订单金额",
          dataIndex: "totalAmount",
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'totalAmount'}
        },
        , ...(authority('taxOrderFee') ?
                [{
                  title: "服务费",
                  dataIndex: "serviceFee",
                  align: "center",
                  width: 100,
                  scopedSlots: {customRender: 'serviceFee'}
                }] : []
        ),
        {
          title: "订单状态",
          dataIndex: "status",
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'status'}
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
          width: 160,
          customRender: (text) => this.formatDateTime(text)
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],

      serviceFeeColumns: [
        {title: "付款账户", dataIndex: "accountNo", align: "center", width: 180, scopedSlots: {customRender: 'sfAccountNo'}},
        {title: "收款账户", dataIndex: "oppAccountNo", align: "center", width: 180, scopedSlots: {customRender: 'sfOppAccountNo'}},
        {title: "金额", dataIndex: "feeAmount", align: "center", width: 100, scopedSlots: {customRender: 'feeAmount'}},
        {title: "支付状态", dataIndex: "paymentStatus", align: "center", width: 80, scopedSlots: {customRender: 'recordStatus'}},
        {title: "结算时间", dataIndex: "settleTime", align: "center", width: 160, scopedSlots: {customRender: 'settleTime'}},
        {title: "操作", key: "action", align: "center", width: 80, scopedSlots: {customRender: 'sfAction'}}
      ],

      profitShareColumns: [
        {title: "渠道商", dataIndex: "oppAccountNo", align: "center", width: 180, scopedSlots: {customRender: 'psAccount'}},
        {title: "分润金额", dataIndex: "shareAmount", align: "center", width: 100, scopedSlots: {customRender: 'shareAmount'}},
        {title: "支付状态", dataIndex: "paymentStatus", align: "center", width: 80, scopedSlots: {customRender: 'recordStatus'}},
        {title: "分润时间", dataIndex: "shareTime", align: "center", width: 160, scopedSlots: {customRender: 'shareTime'}},
        {title: "操作", key: "action", align: "center", width: 80, scopedSlots: {customRender: 'action'}}
      ]
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    },

    async getTableData() {
      try {
        const res = await this.api.getOrderList({
          ...this.paramsData,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {
        merchantNo: '',
        status: null,
      };
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    createOrder() {
      this.$router.push({path: '/tax/orderCreate'});
    },

    async viewBtn(record) {
      try {
        const res = await this.api.getOrderDetail(record.orderNo);
        if (res.code === 200) {
          this.viewData = res.data;
          this.viewModalVisible = true;
        } else {
          message.warning(res.info || "获取订单详情失败");
        }
      } catch (error) {
        console.error("获取订单详情失败:", error);
        message.error("获取订单详情失败");
      }
    },

    async retryServiceFee(record) {
      try {
        const res = await this.api.retryServiceFee({orderNo: record.orderNo});
        if (res.code === 200) {
          message.success("重试成功");
          this.viewBtn({orderNo: record.orderNo});
        } else {
          message.warning(res.info || "重试失败");
        }
      } catch (error) {
        console.error("重试失败:", error);
        message.error("重试失败");
      }
    },

    async retryProfitShare(record) {
      try {
        const res = await this.api.retryProfitShare({
          orderNo: record.orderNo,
          shareRuleId: record.shareRuleId
        });
        if (res.code === 200) {
          message.success("重试成功");
          this.viewBtn({orderNo: record.orderNo});
        } else {
          message.warning(res.info || "重试失败");
        }
      } catch (error) {
        console.error("重试失败:", error);
        message.error("重试失败");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.top-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 16px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.order-detail {
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px;

  .detail-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ .ant-card-head {
      min-height: 40px;
      padding: 0 12px;

      .ant-card-head-title {
        font-size: 14px;
        font-weight: 600;
        padding: 8px 0;
      }
    }

    /deep/ .ant-card-body {
      padding: 12px;
    }
  }

  .detail-value {
    font-weight: 500;
    color: #333;
  }
}
</style>